import {combineReducers} from 'redux'
import types from 'actions/types'
import {get} from 'lodash'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const jobStatus = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS:
      return get(action, 'filters.jobStatus', state)
    default:
      return state
  }
}

export const jobBoard = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS:
      return get(action, 'filters.jobBoard', state)
    default:
      return state
  }
}

export const readyForDeliveryQuotesPivotTableKey = 'deliveriesContext.readyForDelivery.quotes'

export default combineReducers({
  timeKey,
  targetStart,
  targetEnd,
  jobStatus,
  jobBoard,
  quotes: createPivotTableReducer({key: readyForDeliveryQuotesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
})
